var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfxQ9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0C20.1802 0 26 5.81979 26 13C26 20.1802 20.1802 26 13 26C5.81979 26 0 20.1802 0 13C0 5.81979 5.81979 0 13 0Z",
    fill: "#F0B90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14635 12.9988L7.15573 16.4363L10.0766 18.1551V20.1676L5.44635 17.452V11.9936L7.14635 12.9988ZM7.14635 9.56133V11.5645L5.44531 10.5582V8.55508L7.14635 7.54883L8.85573 8.55508L7.14635 9.56133ZM11.2964 8.55508L12.9974 7.54883L14.7068 8.55508L12.9974 9.56133L11.2964 8.55508Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 15.7238V13.7113L10.076 14.7176V16.7207L8.375 15.7238ZM11.2958 18.8759L12.9969 19.8822L14.7062 18.8759V20.879L12.9969 21.8853L11.2958 20.879V18.8759ZM17.1458 8.55508L18.8469 7.54883L20.5562 8.55508V10.5582L18.8469 11.5645V9.56133L17.1458 8.55508ZM18.8469 16.4363L18.8562 12.9988L20.5573 11.9926V17.4509L15.9271 20.1665V18.154L18.8469 16.4363Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6229 15.7254L15.9219 16.7223V14.7191L17.6229 13.7129V15.7254Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6271 10.2747L17.6365 12.2872L14.7073 14.006V17.4518L13.0062 18.4487L11.3052 17.4518V14.006L8.37604 12.2872V10.2747L10.0844 9.26849L12.9958 10.9956L15.925 9.26849L17.6344 10.2747H17.6271ZM8.375 6.83828L12.9969 4.11328L17.6271 6.83828L15.926 7.84453L12.9969 6.11745L10.076 7.84453L8.375 6.83828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfxQ9);
export default __webpack_public_path__ + "static/media/bfx_q (9).2ce981de8fe900e8d436bac0deb65ab8.svg";
export { ForwardRef as ReactComponent };